module.exports = __webpack_public_path__ + "static/media/loading4.69c30014.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading4.png
// module id = 189
// module chunks = 0